import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Thanks! We'll be in touch shortly.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch {
      toast.error("Could not send. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-5">
        <div className="text-xs uppercase tracking-[0.2em] text-gray-500">Contact</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-white">Talk <span className="text-[#8DC63F]">to us.</span></h1>
        <p className="text-gray-400 mt-3 max-w-md">
          Need a hand quoting an unusual job? Want to book over the phone? We&apos;re here.
        </p>
        <div className="mt-6 space-y-3 text-sm">
          <Info icon={<Phone size={16} />} label="Phone" value="0800 000 0000" />
          <Info icon={<Mail size={16} />} label="Email" value="sales@weighaway.co.uk" />
          <Info icon={<MapPin size={16} />} label="Area" value="UK wide — service zones available" />
        </div>
      </div>

      <form onSubmit={submit} className="lg:col-span-7 wa-card space-y-3" data-testid="contact-form">
        <div className="grid sm:grid-cols-2 gap-3">
          <Field label="Name">
            <input required className="wa-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
          </Field>
          <Field label="Email">
            <input required type="email" className="wa-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" />
          </Field>
        </div>
        <Field label="Phone (optional)">
          <input className="wa-input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="contact-phone" />
        </Field>
        <Field label="Message">
          <textarea required rows={5} className="wa-input" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
        </Field>
        <button disabled={sending} className="wa-btn-primary disabled:opacity-50" data-testid="contact-submit">
          {sending ? "Sending…" : "Send message"}
        </button>
      </form>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label className="wa-label">{label}</label>
      {children}
    </div>
  );
}

function Info({ icon, label, value }) {
  return (
    <div className="flex items-center gap-3">
      <div className="w-9 h-9 rounded-full bg-[#8DC63F] text-black grid place-items-center">{icon}</div>
      <div>
        <div className="text-xs uppercase tracking-[0.18em] text-gray-500">{label}</div>
        <div className="font-semibold text-white">{value}</div>
      </div>
    </div>
  );
}
